var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9971 25C17.612 25 17.2426 24.847 16.9704 24.5746C16.698 24.3021 16.545 23.9326 16.545 23.5473V19.4527H12.4521C12.067 19.4527 11.6977 19.2996 11.4253 19.0273C11.153 18.7548 11 18.3854 11 18C11 17.6147 11.153 17.2454 11.4253 16.9728C11.6977 16.7005 12.067 16.5473 12.4521 16.5473H16.545V12.4527C16.545 12.0674 16.698 11.6979 16.9704 11.4255C17.2426 11.1531 17.612 11 17.9971 11C18.3822 11 18.7516 11.1531 19.0238 11.4255C19.2962 11.6979 19.4492 12.0674 19.4492 12.4527V16.5473H23.5479C23.933 16.5473 24.3024 16.7005 24.5746 16.9728C24.847 17.2454 25 17.6147 25 18C25 18.3854 24.847 18.7548 24.5746 19.0273C24.3024 19.2996 23.933 19.4527 23.5479 19.4527H19.455V23.5473C19.455 23.7387 19.4172 23.9281 19.3439 24.1046C19.2707 24.2812 19.163 24.4416 19.0277 24.5766C18.8922 24.7116 18.7315 24.8185 18.5547 24.8911C18.3777 24.9638 18.1882 25.0008 17.9971 25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.461f89eda63aed4ab1245f881a60dba1.svg";
export { ForwardRef as ReactComponent };